<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <icon-card-line
          icon="UsersIcon"
          :statistic="usersNumberCardData.number"
          :statisticTitle="$t('NumeroUsuarios')"
          :statisticSubTitle="$t('DesdeMesPasado')"
          :percent="usersNumberCardData.percent"
          :typePercent="usersNumberCardData.type"
        >
        </icon-card-line>
      </div>
      <div class="vx-col w-full">
        <vx-card class="mb-base" title="Usuarios" >
          <div class="text-right mb-3" >
            <vs-button @click="popupNewUser=true" color="primary" type="border">{{ $t('NuevoUsuario') }}</vs-button>
            <vs-popup classContent="popup-example" :title="$t('NuevoUsuario')" :active.sync="popupNewUser">
              <new-user></new-user>
            </vs-popup>
          </div>
          <ktracer-data-grid :data="users" :dataColumns="dataColumns" link="user"></ktracer-data-grid>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>

  import KtracerDataGrid from '../components/KtracerDataGrid';
  import IconCardLine from '../components/icon-cards/IconCardLine.vue'
  import NewUser from '../components/Users/NewUser.vue'
  import {mapActions, mapState} from 'vuex';

  export default {
    components: {
      KtracerDataGrid,
      IconCardLine,
      NewUser

    },
    data () {
      return {
        dialog: false,
        dataColumns: [
          {dataField: 'id', caption: 'ID', dataType: 'number', visible: true, width: 50},
          {dataField: 'name', caption: 'Nombre', dataType: 'text', visible: true, width: 150},
          {dataField: 'company_name', caption: 'Empresa', dataType: 'text', visible: true},
          {dataField: 'created_at', caption: 'Fecha alta', dataType: 'date', visible: true, width: 100},
          {dataField: 'zones', caption: 'Zonas de actividad', dataType: 'text', visible: false},
        ],
        popupNewUser:false
      }
    },
    created () {
      this.refreshUsers();
    },
    computed: {
      ...mapState({
        users: state => state.users.items,
        usersNumberCardData: state => state.users.usersNumberCardData,
      }),
    },
    methods: {
      ...mapActions({
        refreshUsers: 'refreshUsers',
      })
    }
  }

</script>

<style>

</style>
